<template>
  <div class="rotator-container">

    <div class="return-to-controls" @click="returnToControls">
      <div class="top-bar bar"></div>
      <div class="bottom-bar bar"></div>
    </div>

    <Breadcrumbs @breadcrumb-home="home" @breadcrumb-click="changeElType"
        :breadcrumbList="breadcrumbList" :position="$store.state.rotator.activeType" v-model="initialized" />

    <div class="proxy-holder">
      <transition-group name="fade" mode="out-in" tag="div" :duration="300">
        <ProxyFrame ref="proxy-iframe" key="frame"
          :style="frameStyle" class="proxy-iframe-container" :class="{ offset: $store.state.rotator.activeType < 0}"/>
        <UrlView v-show="$store.state.rotator.activeType < 0" @submit="submit" key="url" />
      </transition-group>
    </div>

    <transition mode="out-in" name="panel-toggle">
      <SlideoutContainer v-if="this.$store.state.rotator.activeType == -1 && instructionState">
        <span slot="title">GETTING STARTED</span>
        <div slot="body">
          <div class="instruction-video">
            <iframe width="853" height="480" src="https://www.youtube.com/embed/VwrSHyMUO0U?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            <br><br><br><br>
            <button class="form-button__default form-button__largetext" @click="instructionState = false">
              {{ this.$store.state.rotator.activeType >= 0 ? 'Close Instructions' : 'Ready to Integrate'  }}
            </button>
          </div>
        </div>
      </SlideoutContainer>
    </transition>
    <transition mode="out-in" name="fade">
      <SlideoutContainer v-if="this.$store.state.rotator.activeType == 5">
        <span slot="title">SDK INTEGRATION</span>
        <div slot="body">
          <Instruction />
        </div>
      </SlideoutContainer>
    </transition>
    <el-tooltip effect="dark" content="Getting Started" placement="bottom">
      <div class="speeddial-holder instruction-dial" ref="instructionState" @click="instructionState = true"
          :class="this.$store.state.rotator.activeType == -1 && !instructionState  ? 'shrink' : ''">
        <div class="speeddial-btn speeddial-btn__parent">
          <i class="el-icon-info"></i>
        </div>
      </div>
    </el-tooltip>

    <transition name="scale" tag="div">
      <div class="button-collection" v-show="this.$store.state.rotator.activeType >= 0 && this.$store.state.rotator.activeType <= 4">
        <SpeedDialMenu :delay="45">
          <SpeedDialItem @click="changeWidth('360px')">
            <div v-html="SVGGraphics.default.mobile" class="height-fix"></div>
          </SpeedDialItem>
          <SpeedDialItem @click="changeWidth('100%')" :initial="true">
            <div v-html="SVGGraphics.default.desktop" class="height-fix"></div>
          </SpeedDialItem>
        </SpeedDialMenu>

        <el-tooltip effect="dark" content="Next Step" placement="bottom">
          <div class="speeddial-holder" @click="nextEl">
            <div class="speeddial-btn speeddial-btn__parent">
              <div class="morph-icon">
                <div class="morph-bar morph-bar__top"></div>
                <div class="morph-bar morph-bar__bottom"></div>
                <div class="morph-bar morph-bar__download"></div>
              </div>
            </div>
          </div>
        </el-tooltip>
      </div>
    </transition>
  </div>
</template>

<script>
import UrlView from './Radius/URL.vue';
import ProxyFrame from './Radius/ProxyFrame.vue';
import SpeedDialMenu from './Radius/Elements/SpeedDialMenu.vue';
import SpeedDialItem from './Radius/Elements/SpeedDialItem.vue';
import NextStepButton from './Radius/Elements/NextStepButton.vue';
import SlideoutContainer from './Radius/StepSlideoutModal/SlideoutContainer.vue';
import Breadcrumbs from './Radius/Breadcrumb/Breadcrumbs.vue';
import Instruction from './Radius/Instruction.vue';

var SVGGraphics = require('./Radius/svg-graphics');

const BREADCRUMB_LIST = [
  'Product Image',
  'Product Name',
  'Product Price',
  'Redirect Link',
  'Preview',
  'Finish'
];

export default {
  name: 'Rotator',

  components: {
    UrlView, ProxyFrame, SpeedDialMenu, SpeedDialItem, NextStepButton, Breadcrumbs, SlideoutContainer, Instruction
  },

  created() {
    if (this.$isTouch) {
      this.$notify.error({
        title    : 'Error',
        message  : 'Sorry, the setup wizard does not currently support touch screen devices',
        position : 'bottom-right'
      })
      return this.$router.replace({ name: 'rotator_id', params: { id: this.$route.params.id }})
    }

    this.$store.commit('resetRotatorState')
    this.$store.commit('setRotatorId', this.$route.params.id)
    this.home()

    if (!this.$store.state.rotator.data || this.$store.state.rotator.rotator_id != this.$route.params.id) {
      this.$store.dispatch('getRotator')
    }
  },

  data() {
    return {
      prev                      : null,
      breadcrumbList            : BREADCRUMB_LIST,
      frameStyle                : { width: '100%' },
      showTooltip               : false,
      instructionState          : true,
      SVGGraphics
    }
  },

  computed: {
    showDownload() {
      return (this.$store.state.rotator.activeType == this.breadcrumbList.length - 1)
    },
    initialized() {
      return this.$store.state.rotator.activeUrl && this.$store.state.rotator.activeUrl.length > 0;
    }
  },

  watch: {
    '$store.state.rotator.activeType'(newVal) {
      // Hide instructions when moving away from start page
      if (newVal >= 0)
        this.instructionState = false
    },
    '$store.state.rotator.data'(newVal) {
      if (!newVal) {
        this.$notify.error({
          title    : 'Error',
          message  : 'Rotator does not exist',
          position : 'bottom-right'
        })
        this.$router.replace({ name: 'rotator' })
      }
    }
  },

  methods: {
    submit() {
      this.changeElType();
    },

    changeElType(index = 0) {
      if (!this.initialized)
        return

      index = Math.min(index, this.breadcrumbList.length - 1)
      this.$store.commit('setActiveType', index)
      this.$store.commit('setLivePreview', index == 4 || (index >= 4 && this.$store.state.rotator.livePreview))
    },

    nextEl() {
      if (this.showDownload) {
        return;
      } else {
        this.changeElType(this.$store.state.rotator.activeType + 1);
      }
    },

    home() {
      this.changeElType(-1)
    },
    changeWidth(width) {
      const margin = width.indexOf('px') !== -1
        ? 'calc(50% - (' + width + ' / 2))'
        : '0'
      
      this.frameStyle = { width: width, 'margin-left': margin }
    },
    returnToControls(id) {
      this.$router.replace({ name: 'rotator_id', params: this.$route.params })
    }
  }
}
</script>

<style lang="scss" scoped>

@import '~static/mixins/global';
@import '~static/mixins/variables';

.fade-transition {
  transition: all 0.4s ease;
  overflow: hidden;
  visibility: visible;
  opacity: 1;
}
.fade-transition {
  /* Delay for showing the content after the loader has been hidden */
  transition-delay: 0.4s;
}
.fade-enter, .fade-leave {
  opacity: 0;
  visibility: hidden;
}

.slideout-container{
  transition: .3s all;
  transform-origin: bottom left;
}

.panel-toggle-leave-active,
.panel-toggle-enter{
  transform: scale(.1);
  opacity: 0;
  border-radius:0 100% 0 0;
}
.panel-toggle-enter-actiev{
  opacity: 1;
  transform: scale(1) translate3d(0,0,0);
}


.instruction-dial{
  position: absolute;
  left: 10px;
  opacity: 0;
  bottom: 20px;
  transition: .3s all;
  transform: scale(0);
  &.shrink{
    transform: scale(1);
    transform-origin: center;
    opacity: 1;
  }
  i{
    font-size: 58px;
    line-height: 70px;
  }
}

.rotator-container
{ /*ROTATOR CONTAINER*/
  padding-top: 50px;
  position: relative;
  height: inherit;
  overflow: hidden;
  background-size: cover;
  margin: 0;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  a {
    color: #42b983;
  }
  .button-collection {
    z-index: 20;

    @include placementBundle(absolute, initial, 100px, 20px, initial);
  }
  .height-fix{
    height: inherit;
  }
  .proxy-holder {
    position: fixed;
    width: 100%;
    height: calc(100% - 50px);
  }
  .proxy-holder > div {
    height: 100%;
  }
  .proxy-iframe-container {
    transition: all .3s, transform 1ms;
    margin: 0 auto;
    overflow: hidden;
    height: 100%;
    position: absolute;

    &.offset {
      transform: translateX(-200%);
    }
  }
}
.return-to-controls
{ /*Return Controls*/
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1001;
  width: 60px;
  height: 50px;
  background: #efefef;

  .bar{
    width: 4px;
    height: 30px;
    border-radius: 5px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    position: absolute;
    background: #bbbbbb;
    transform: rotate(90deg);
    opacity: 0;
    cursor: pointer;
    transition: all .3s;
    &.top-bar{
      animation: topBar .5s forwards;
      animation-delay: .5s;
    }
    &.bottom-bar{
      animation: bottomBar .5s forwards;
      animation-delay: .5s;
    }
  }
  &:hover{
    .bar{
      background: #6f6f6f;
    }
  }
}
.play-btn{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(215, 200, 215, .3);
  display: table;
  .play-icon{
    display: table-cell;
    vertical-align: middle;
  }
  i{
    font-size: 80px;
    background: rgba(30, 30, 30, .9);
    color: #fff;
    border-radius: 100%;
    cursor: pointer;
    text-align: center;
    position: relative;
    z-index: 10;
    margin: auto;
  }
}
@keyframes topBar {
  0%{
    opacity: 0;
  }
  100%{
    transform: rotate(47deg);
    opacity: 1;
  }
}
@keyframes bottomBar {
  0%{
    opacity: 0;
  }
  100%{
    transform: rotate(-47deg);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// radius.vue?cae88d60